<template>
  <div id="app">
    <Header v-if="$route.path !== '/mobile-guide'" />
    <router-view/>
    <Footer v-if="$route.path !== '/mobile-guide'" />
    
    <!-- 悬浮客服按钮 -->
    <div class="floating-kefu" @click="handleKefuClick" v-if="kefuUrl && $route.path !== '/mobile-guide'">
      <div class="kefu-icon">
        <i class="el-icon-headset"></i>
      </div>
      <div class="kefu-text">在线客服</div>
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import { getKefuList } from '@/api/kefu'

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      kefuUrl: ''
    }
  },
  created() {
    this.checkDevice()
  },
  mounted() {
    this.fetchKefuInfo()
  },
  methods: {
    checkDevice() {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      const currentPath = this.$route ? this.$route.path : window.location.pathname
      if (isMobile && currentPath !== '/mobile-guide') {
        this.$router.replace('/mobile-guide').catch(err => {
          if (err.name !== 'NavigationDuplicated') console.error(err)
        })
      }
    },
    async fetchKefuInfo() {
      // 路由是引导页时不展示客服，也不请求
      if (this.$route.path === '/mobile-guide') return
      try {
        const res = await getKefuList({ position: 'Kefu' })
        if (res.code === 200 && res.rows && res.rows.length > 0) {
          // 优先使用 url 字段，如果没有则可能是在线咨询链接
          this.kefuUrl = res.rows[0].url || res.rows[0].link
        }
      } catch (error) {
        console.error('获取客服信息失败:', error)
      }
    },
    handleKefuClick() {
      if (this.kefuUrl) {
        window.open(this.kefuUrl, '_blank')
      }
    }
  },
  watch: {
    '$route.path'() {
      this.checkDevice()
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Microsoft YaHei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  position: relative;
}

.floating-kefu {
  position: fixed;
  right: 30px;
  bottom: 100px;
  z-index: 2000;
  width: 60px;
  height: 60px;
  background-color: #e1251b;
  border-radius: 50%;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(225, 37, 27, 0.3);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(225, 37, 27, 0.4);
    background-color: #f12c20;
  }

  .kefu-icon {
    font-size: 24px;
    margin-bottom: 2px;
  }

  .kefu-text {
    font-size: 10px;
    font-weight: bold;
  }
}

// 当屏幕较小时调整位置
@media (max-width: 768px) {
  .floating-kefu {
    right: 20px;
    bottom: 80px;
    width: 50px;
    height: 50px;
    
    .kefu-icon {
      font-size: 20px;
    }
    .kefu-text {
      font-size: 9px;
    }
  }
}
</style>
